export const INCOME_ACCOUNT_TYPE = "הכנסה" as const;
export const INCOMES_PATH = "/incomes";
export const INCOMES_BREADCRUMB = { ledger: "כרטסות", list: "הכנסות" } as const;
export const INCOMES_STRUCTURE_CRUMBS = {
  browse: "הגדרת מבנה דפדוף",
} as const;